/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React from 'react';

const ScoreDetails = ({ details }) => {
  // Calculate total score from all fields
  const totalScore = (details.greetings || 0) + 
                    (details.knowledge || 0) + 
                    (details.resolution || 0) + 
                    (details.communtication_skills || 0) + 
                    (details.problem_solving || 0) + 
                    (details.process_adherence || 0) + 
                    (details.closing || 0) + 
                    (details.customer_experience || 0) + 
                    (details.retention_pitch || 0) + 
                    (details.listening_skills || 0) + 
                    (details.retention_drive || 0);

  return (
    <div
      id="score-details"
      className="modal fade in"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title text-center" id="myModalLabel">
              Score Details
            </h4>
            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
              ×
            </button>
          </div>
          <div className="modal-body">
            <div className="col-6 d-flex mb-4">
              <div>
                <label label className="copy-font m-0 p-0">
                  Extension
                </label>
                <input type="number" className="form-control" placeholder="200" value={details.extension} readOnly />
              </div>
            </div>
            <table className="table score-agent-table">
              <thead>
                <tr>
                  <th>Section</th>
                  <th>Description</th>
                  <th nowrap="no-wrap">Score (100%)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th nowrap="no-wrap">Section 1</th>
                  <th>Welcome</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent say Welcome to Tizeti(Company's Name) and end the call properly?</td>
                  <th>{details.greetings}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 2</th>
                  <th>Knowledge</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent have sufficient knowledge of the products and services the company offers?</td>
                  <th>{details.knowledge}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 3</th>
                  <th>Resolution</th>
                </tr>
                <tr>
                  <td />
                  <td>
                    Did the agent build relationship with the customer and show commitment to resolving the issue?
                  </td>
                  <th>{details.resolution}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 4</th>
                  <th>Communication Skills</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent demonstrate clear and effective communication throughout the call?</td>
                  <th>{details.communtication_skills}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 5</th>
                  <th>Problem Solving</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent effectively identify and solve the customer's problem?</td>
                  <th>{details.problem_solving}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 6</th>
                  <th>Process Adherence</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent follow company procedures and protocols correctly?</td>
                  <th>{details.process_adherence}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 7</th>
                  <th>Closing</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent properly close the call and ensure customer satisfaction?</td>
                  <th>{details.closing}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 8</th>
                  <th>Customer Experience</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent provide an overall positive customer experience?</td>
                  <th>{details.customer_experience}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 9</th>
                  <th>Retention Pitch</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent make an appropriate retention pitch when necessary?</td>
                  <th>{details.retention_pitch}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 10</th>
                  <th>Listening Skills</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent demonstrate active listening and understanding?</td>
                  <th>{details.listening_skills}%</th>
                </tr>

                <tr>
                  <th nowrap="no-wrap">Section 11</th>
                  <th>Retention Drive</th>
                </tr>
                <tr>
                  <td />
                  <td>Did the agent show initiative in customer retention efforts?</td>
                  <th>{details.retention_drive}%</th>
                </tr>

                {/* Total */}
                <tr>
                  <td />
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <b>{totalScore}%</b>
                  </td>
                </tr>
                <tr>
                  <th>Feedback</th>
                  <td>
                    <textarea
                      readOnly="readonly"
                      rows="8"
                      cols="50"
                      name="score"
                      placeholder={details.feedback}
                      className="form-control"
                    >
                      {details.feedback}
                    </textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoreDetails;